/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { DomainService } from './DomainService';

class DomainServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new DomainService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { DomainServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/DomainServiceProvider.js